"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var scenario_selectors_1 = require("../../redux/scenario/scenario.selectors");

var use_set_action_preview_hook_1 = __importDefault(require("../action-preview/use-set-action-preview.hook"));

var greeting_scenario_node_action_view_component_1 = __importDefault(require("./greeting-scenario-node-action-view.component"));

var GreetingScenarioNodeActionViewContainer = function GreetingScenarioNodeActionViewContainer() {
  var node = react_redux_1.useSelector(scenario_selectors_1.selectGreetingScenarioNode);

  var _use_set_action_previ = use_set_action_preview_hook_1.default(),
      setActionPreview = _use_set_action_previ.setActionPreview,
      resetActionPreview = _use_set_action_previ.resetActionPreview;

  if (!node) return null;
  var option = node.options[0];
  return react_1.default.createElement(greeting_scenario_node_action_view_component_1.default, {
    option: option,
    handleMouseEnter: function handleMouseEnter() {
      return setActionPreview(option);
    },
    handleMouseLeave: function handleMouseLeave() {
      return resetActionPreview();
    }
  });
};

exports.default = GreetingScenarioNodeActionViewContainer;